export const languagesEnum = [
    {
        LanguageID: 1,
        LanguageName: "English (United States)"
    },
    {
        LanguageID: 285,
        LanguageName: "Hebrew (Israel)"
    }
]
